import React from 'react';
import T from 'i18n-react';

import { FilterIcon } from '@motorway/motorway-storybook-cra';
import { Select } from '@motorway/mw-highway-code/pre-alpha';

import useAccountRouter from 'Components/Account/useAccountRouter';
import texts from 'Components/texts.json';
import { triggerAccountDateFilterClicked } from 'Services/analytics/events';
import { applyCypressData } from 'Utilities/helpers';

import { defaultAccountDateRanges } from './AccountDateRangeFilter.helpers';
import type { AccountDateRangeFilterProps } from './AccountDateRangerFilter.types';

import styles from './AccountDateRangeFilter.module.scss';

T.setTexts(texts);

const AccountDateRangeFilter: React.FC<AccountDateRangeFilterProps> = ({
	cypressDataId,
	dateRanges = defaultAccountDateRanges,
	label = '',
	showMobileButtonOverlay = true,
}) => {
	const { dateRangeType, slug } = useAccountRouter();
	const { changePage } = useAccountRouter();

	const onChangeHandler = ({ target: { value } }: React.ChangeEvent<HTMLSelectElement>) => {
		changePage({ dateRangeType: value });

		triggerAccountDateFilterClicked({ filter: value, slug });
	};

	return (
		<div className={styles.accountDateRangeFilterWrapper}>
			{showMobileButtonOverlay && (
				<div className={styles.mobileLabelContainer}>
					<div className={styles.mobileLabel}>
						{T.translate('account.dateRangeFilter.buttonLabel')}
						<FilterIcon />
					</div>
				</div>
			)}
			<Select
				data-thc-select
				fullWidth
				formProps={{
					input: {
						onChange: onChangeHandler,
						...applyCypressData(cypressDataId),
						value: dateRangeType,
					},
				}}
				id="AccountDateRangeFilter"
				label={label}
				showLabel={!!label}
			>
				{dateRanges.map((key) => (
					<option key={key} value={key}>
						{T.translate(`account.dateRangeFilter.${key}`)}
					</option>
				))}
			</Select>
		</div>
	);
};

AccountDateRangeFilter.displayName = 'AccountDateRangeFilter';

export default AccountDateRangeFilter;
